import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react'
import { useAuth } from './AuthContext'
import { GET } from 'api/request'
import * as urls from 'api/urls'

interface BorderList {
  data?: board.BoardsListResponse
  isLoading: boolean
  reload: base.BasicFunc
}

const BorderListContext = createContext<BorderList>({
  isLoading: false,
  reload: () => { }
})

export const useBorderListContext = () => {
  const context = useContext(BorderListContext)
  if (!context) {
    throw new Error('useLanguage must be used within a BorderListProvider')
  }
  return context
}

export const BorderListProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [data, setData] = useState<undefined | board.BoardsListResponse>(undefined)
  const [isLoading, setLoading] = useState(false)
  const { user } = useAuth()

  const fetchDetails = async () => {
    setLoading(true)
    try {
      const response = await GET(urls.boardslist)
      if (response.ok) {
        setData(response.data)
      } else {
        throw new Error(response.data.message)
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)
      console.error('Fetch failed: ', error)
    }
  }

  useEffect(() => {
    fetchDetails()
  }, [user])

  return (
    <BorderListContext.Provider value={{ data, isLoading, reload: fetchDetails }}>
      {children}
    </BorderListContext.Provider>
  )
}